import { AuthologicConversationResult, AuthologicStatusResponse, FinishMojeIdRegistrationRequest } from 'features/auth/registrationMojeId/types';
import { currentLanguage } from 'shared/constants/common';
import { findCookieValue } from 'shared/util/utility';
import { FinishMojeIdVerificationRequest, VerificationMojeIdConversationResult } from '../features/auth/verificationMojeId/types';
import { RequestsInstance } from './index';

export const AuthologicApiWrapper = (requests: RequestsInstance) => {
	const getConfig = () => ({
		headers: {
			'Request-Language': currentLanguage,
			'x-odds-session': findCookieValue('x-odds-session'),
		},
	});

	const baseUrl = '/authologic';

	return {
		REJECTION_REASON_EXPIRED: '998',
		REJECTION_REASON_UNKNOWN: '999',
		registrationMojeId: {
			initialize: () => {
				return requests.post<AuthologicStatusResponse>(`${baseUrl}/initialize/registrationMojeId`, getConfig());
			},
			check: (id: string) => {
				return requests.getRaw<AuthologicConversationResult>(`${baseUrl}/check/registrationMojeId/${id}`, getConfig());
			},
			finish: (id: string, data: FinishMojeIdRegistrationRequest) => {
				return requests.post<AuthologicConversationResult>(`${baseUrl}/finish/registrationMojeId/${id}`, data, getConfig());
			},
		},
		verificationMojeId: {
			initialize: () => {
				return requests.post<AuthologicStatusResponse>(`${baseUrl}/initialize/verificationMojeId`, getConfig());
			},
			check: (id: string) => {
				return requests.getRaw<VerificationMojeIdConversationResult>(`${baseUrl}/check/verificationMojeId/${id}`, getConfig());
			},
			finish: (id: string, data: FinishMojeIdVerificationRequest) => {
				return requests.post<VerificationMojeIdConversationResult>(`${baseUrl}/finish/verificationMojeId/${id}`, data, getConfig());
			},
		},
	};
};
